import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "base";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    async auditCostOrder({ commit }, payload) {
      // 审核费用收入、支出订单
      let result = await api.post("/api/AuditOrder/AuditCostOrder", payload);
      return result;
    },
    async auditCostOrderByMouth({ commit }, payload) {
      // 按月批量审核费用收入、支出单
      let result = await api.post("/api/AuditOrder/AuditCostOrderByMouth", payload);
      return result;
    },
    async auditFishOrder({ commit }, payload) {
      // 审核苗种采购、成鱼销售订单
      let result = await api.post("/api/AuditOrder/AuditFishOrder", payload);
      return result;
    },
    async auditFishOrderByMouth({ commit }, payload) {
      // 按月批量审核苗种采购、成鱼销售订单
      let result = await api.post("/api/AuditOrder/AuditFishOrderByMouth", payload);
      return result;
    },
    async auditMaterialOrder({ commit }, payload) {
      // 审核饲料、药品采购及投喂单、防疫单等订单
      let result = await api.post("/api/AuditOrder/AuditMaterialOrder", payload);
      return result;
    },
    async auditMaterialOrderByMouth({ commit }, payload) {
      // 按月批量审核饲料、药品采购等订单
      let result = await api.post("/api/AuditOrder/AuditMaterialOrderByMouth", payload);
      return result;
    },
    async auditFeedOrderByMouth({ commit }, payload) {
      // 按月批量审核投喂单
      let result = await api.post("/api/AuditOrder/AuditFeedOrderByMouth", payload);
      return result;
    },
    async auditPrecautionOrderByMouth({ commit }, payload) {
      // 按月批量审核防疫单
      let result = await api.post("/api/AuditOrder/AuditPrecautionOrderByMouth", payload);
      return result;
    },
  }
});

export default moduleName;
